<template>
  <div v-if="isOpRole" class="op-duty-bar">
    <el-tooltip placement="bottom" :content="tooltipText">
      <div class="op-duty-bar__inner">
        <span class="op-duty-bar__dot" :class="{ 'is-on': onDuty }" aria-hidden="true" />
        <span class="op-duty-bar__label">{{ statusLabel }}</span>
        <el-switch
          v-model="onDuty"
          :disabled="!token || loading"
          @change="onSwitchChange"
        />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fetchOpDutyStatus, setOpDuty } from '@/api/hotelOrder'

export default {
  name: 'OpDutyBar',
  data() {
    return {
      onDuty: false,
      loading: false,
      bootstrapped: false
    }
  },
  computed: {
    ...mapGetters(['roles', 'token']),
    isOpRole() {
      const rs = this.roles || []
      return rs.some(r => String(r).toUpperCase() === 'OP')
    },
    statusLabel() {
      if (!this.bootstrapped || this.loading) {
        return '接单状态'
      }
      return this.onDuty ? '接单中' : '已下班'
    },
    tooltipText() {
      return '打开表示正在接单，美团直连新单会在上班 OP 间按单量均衡分配。退出或关页面不会自动下班，仍占上班名额；真正下班请关闭本开关'
    }
  },
  watch: {
    token(val) {
      if (!val) {
        this.onDuty = false
        this.bootstrapped = false
      }
    },
    isOpRole: {
      immediate: true,
      handler(v) {
        if (v) {
          this.refreshStatus()
        } else {
          this.bootstrapped = false
        }
      }
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.onVisibility)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibility)
  },
  methods: {
    onVisibility() {
      if (document.visibilityState === 'visible' && this.isOpRole && this.token) {
        this.refreshStatus()
      }
    },
    refreshStatus() {
      if (!this.token || !this.isOpRole) {
        return
      }
      this.loading = true
      fetchOpDutyStatus()
        .then(res => {
          const d = res && res.data != null ? res.data : {}
          this.onDuty = !!d.onDuty
          this.bootstrapped = true
        })
        .catch(() => {
          this.onDuty = false
          this.bootstrapped = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSwitchChange(val) {
      if (!this.isOpRole) {
        return
      }
      this.loading = true
      setOpDuty(val)
        .then(res => {
          const d = res && res.data != null ? res.data : {}
          this.onDuty = !!d.onDuty
          const msg = this.onDuty ? '已开始接单' : '已下班'
          this.$message.success(msg)
        })
        .catch(err => {
          const m = (err && err.response && err.response.data && err.response.data.message) || '切换失败'
          this.$message.error(m)
          this.onDuty = !val
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.op-duty-bar {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 4px;

  &__inner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 12px 6px 10px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.72);
    border: 1px solid rgba(180, 150, 110, 0.35);
    box-shadow: 0 4px 14px rgba(62, 42, 16, 0.06);
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #94a3b8;
    flex-shrink: 0;
    transition: background 0.2s ease, box-shadow 0.2s ease;

    &.is-on {
      background: #16a34a;
      box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.25);
    }
  }

  &__label {
    font-size: 13px;
    font-weight: 500;
    color: #334155;
    white-space: nowrap;
    max-width: 88px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ::v-deep .el-switch__core {
    min-width: 44px;
  }
}

@media (max-width: 900px) {
  .op-duty-bar__label {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/OpDutyBar.vue